import { useTranslation } from 'next-i18next'

import SVGImage from '~/components/Image/SVGImage'

import TimeStat from '../ProfileCards/TimeStat'

interface Props {
  days: number
  hours: number
  minutes: number
}

export default function TimeSpent({ days, minutes, hours }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')

  return (
    <div className="flex items-center">
      <SVGImage alt={t('alt_texts.clock')} className="mr-2" height={20} srcKey="scoreboard/clock.svg" width={20} />
      <TimeStat days={days} hours={hours} minutes={minutes} />
    </div>
  )
}
